<template>
    <div class="modal-overlay">
        <transition name="modal-expand">
            <div v-if="isVisible" class="products-modal" @click.stop>
                <div class="modal-content" @click.stop>
                    <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
                    <h2>Logbook rules</h2>

              <div class="artificial-fieldset-steps">
                <div class="legend-wrapper">
                  <span class="artificial-fieldset-steps-legend">PDF pages</span>
                </div>
                <div class="form-group">
                  <label for="cover-upload">Cover Page:</label>
                  <!-- <input type="file" id="cover-upload" class="form-control rounded" accept="application/pdf"
                    @change="handleFileUpload('cover', $event)" /> -->

                  <!-- Show existing PDF -->
                  <div v-if="documents.cover" class="mt-2">
                    <p>
                      <a :href="documents.cover.file_url" target="_blank">
                        📄 View
                      </a>
                    </p>
                  </div>
                  <div v-else class="mt-2">
                    <p style="margin-top: 6px; color: red;">
                      File not uploaded
                    </p>
                  </div>
                </div>

                <div class="form-group">
                  <label for="revision-upload">List of Revisions Page:</label>
                  <!-- <input type="file" id="revision-upload" class="form-control rounded" accept="application/pdf"
                    @change="handleFileUpload('revisions', $event)" /> -->

                  <!-- Show existing PDF -->
                  <div v-if="documents.revisions" class="mt-2">
                    <p>
                      <a :href="documents.revisions.file_url" target="_blank">
                        📄 View
                      </a>
                    </p>
                  </div>
                  <div v-else class="mt-2">
                    <p style="margin-top: 6px; color: red;">
                      File not uploaded
                    </p>
                  </div>
                </div>

                <div class="form-group">
                  <label for="description-upload">Description Page:</label>
                  <!-- <input type="file" id="description-upload" class="form-control rounded" accept="application/pdf"
                    @change="handleFileUpload('description', $event)" /> -->

                  <!-- Show existing PDF -->
                  <div v-if="documents.description" class="mt-2">
                    <p>
                      <a :href="documents.description.file_url" target="_blank">
                        📄 View
                      </a>
                    </p>
                  </div>
                  <div v-else class="mt-2">
                    <p style="margin-top: 6px; color: red;">
                      File not uploaded
                    </p>
                  </div>
                </div>

                <div class="form-group">
                  <label for="instructions-upload">Instructions for Use:</label>
                  <!-- <input type="file" id="instructions-upload" class="form-control rounded" accept="application/pdf"
                    @change="handleFileUpload('instructions', $event)" /> -->

                  <!-- Show existing PDF -->
                  <div v-if="documents.instructions" class="mt-2">
                    <p>
                      <a :href="documents.instructions.file_url" target="_blank">
                        📄 View
                      </a>
                    </p>
                  </div>
                  <div v-else class="mt-2">
                    <p style="margin-top: 6px; color: red;">
                      File not uploaded
                    </p>
                  </div>
                </div>

                <div class="form-group">
                  <label for="assessment-upload">Validation and Assessment Rules:</label>
                  <!-- <input type="file" id="assessment-upload" class="form-control rounded" accept="application/pdf"
                    @change="handleFileUpload('validation', $event)" /> -->

                  <!-- Show existing PDF -->
                  <div v-if="documents.validation" class="mt-2">
                    <p>
                      <a :href="documents.validation.file_url" target="_blank">
                        📄 View
                      </a>
                    </p>
                  </div>
                  <div v-else class="mt-2">
                    <p style="margin-top: 6px; color: red;">
                      File not uploaded
                    </p>
                  </div>
                </div>
              </div>
                </div>
            </div>
        </transition>
    </div>
</template>


<script>
import axios from 'axios';
//import draggable from 'vuedraggable'

export default {
    data() {
        return {
            isVisible: false,
            productId: parseInt(localStorage.getItem('productId')),
            documents: [],
            files: {
                cover: null,
                revisions: null,
                description: null,
                instructions: null,
                validation: null
            },
        };
    },
    mounted() {
        this.isVisible = true;
        this.fetchPdfs();
        window.addEventListener('show-alert', this.handleShowAlert);
    },
    beforeUnmount() {
        window.removeEventListener('show-alert', this.handleShowAlert);
    },
    methods: {
        close() {
            this.$emit('close');
        },
        async uploadPdf(productId) {
            const formData = new FormData();

            formData.append('product_id', productId);

            // Convert your this.files object into arrays of files and types
            for (const type in this.files) {
                const file = this.files[type];
                if (file) {
                    formData.append('files[]', file);      // actual file
                    formData.append('file_types[]', type); // corresponding type
                }
            }

            try {
                const token = localStorage.getItem('token');
                const headers = {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                };

                const response = await axios.post('/api/documents/batch', formData, { headers });

                if (response.status === 200) {
                    console.log('PDFs updated successfully:', response.data);
                    window.alert('All PDFs updated successfully!');
                } else {
                    this.errorMessage = 'Failed to upload PDF.';
                    this.showAlert = true;
                }
            } catch (error) {
                console.error(error);
                this.errorMessage = error.response?.data?.message || 'An error occurred during PDF upload.';
                this.showAlert = true;
            }
        },
        async fetchPdfs() {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                console.error('Unauthorized');
                return;
                }

                const headers = { Authorization: `Bearer ${token}` };
                const response = await axios.get(`/api/products/${this.productId}/documents`, { headers });

                if (response.status === 200) {
                const docsArray = response.data;

                // Map to easily access by type
                this.documents = docsArray.reduce((acc, doc) => {
                    acc[doc.file_type] = doc;
                    return acc;
                }, {});

                console.log('Mapped documents:', this.documents);
                }
            } catch (error) {
                console.error('Error retrieving Documents:', error);
            }
        },
    }
};

</script>

<style scoped>
.kanban-column {
    min-height: 300px;
}

.lists-container {
    display: flex;
    justify-content: space-between;
}

.list {
    width: 250px;
    padding: 8px;
}

.lists-container ul {
    list-style: none;
    padding: 0;
}

.element {
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.7);
    border: 1px solid grey;
    padding: 3px;
    border-radius: 3px;
    padding-left: 8px;
}

.assign-button {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    /* Updated to stack buttons vertically */
}

.assign-button button {
    font-size: 20px;
    background-color: #0a407a;
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 5px;
    margin-bottom: 5px;
    /* Optional: Add margin between buttons */
    margin-right: 20px;
}

.dropdown {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 200px;
}

.dropdown-menu {
    display: none;
    background-color: #f1f1f1;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 10px;
    z-index: 1;
    position: absolute;
}

/* Display the dropdown menu when showDropdown is true */
.dropdown-menu-active {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    /* Display 3 columns */
    background-color: #f1f1f1;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 10px;
    z-index: 1;
    position: absolute;
    width: 600px;
}

table {
    border-collapse: collapse;
}

th,
td {
    border: 1px solid black;
    padding: 8px;
    border: 1px solid white;
}

.modal-overlay {
    position: fixed;
    top: 0px;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    z-index: 1;
}

.products-modal {
    background-color: #fff;
    max-height: 95vh;
    max-width: 90%;
    min-width: min(80%, 1000px);
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    position: fixed;
    display: block;
    z-index: 1001;

}

.aircraftdropdown,
.productsearch,
.specificdropdown {
    height: 40px;
    /* adjust this value as needed --*/
    margin-bottom: 10px;
    width: 85%;
    margin-left: 40px;
}

.modal-content {
    position: relative;
    max-height: 90vh;
    overflow-y: auto;
    padding: 15px;
}

h2 {
    margin-top: 10px;
    font-size: 30px;
}

table {
    width: 100%;
}

.saveButton {
    background-color: #0a407a;
    color: #ffffff;
    padding: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: auto;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    align-self: center;
}

.alert-danger {
    color: #ff0019;
    background-color: #f8d7da;
    border: 1px solid #e6b0b6;
}

.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 0rem;
    border: 1px solid transparent;
    border-radius: .25rem;
}

.form-control.rounded {
    height: 40px;
}

.form-group {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.form-group label {
    width: 270px;
    margin-right: 50px;
    text-align: right;
    margin-bottom: 0px;
}

.form-group input.form-control,
.form-group select.form-control {
    flex: 1;
    width: auto;
    margin-left: 0;
    margin-bottom: 0px;
    border: 1px solid #ccc
}

.artificial-fieldset-steps {
    border: 1px solid #8b8b8b;
    padding: 30px 10px 10px 10px;
    margin: 20px;
    margin-bottom: 20px;
    border-radius: 4px;
    width: 96%;
}

.legend-wrapper {
    float: left;
    margin-top: -42px;
    margin-left: 10px;
    background-color: #e4e4e4;
    border: 1px solid #8b8b8b;
    border-radius: 3px;
}

.artificial-fieldset-steps-legend {
    font-size: 14px;
    font-weight: bold;
    padding: 2px 8px;
}

span {
    border: 0px;
}
</style>